import { useFormContext } from 'react-hook-form'

import { FIELD_NAMES } from '../validation'

export const useIsFullImpairment = () => {
  const { watch } = useFormContext()
  const impairedAmount = watch(FIELD_NAMES.impaired_amount, 0)
  const impairedAmountMaximum = watch(FIELD_NAMES.impaired_amount_maximum, 0)

  return impairedAmount === impairedAmountMaximum
}
